import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "form" };
const _hoisted_2 = { class: "form-details" };
const _hoisted_3 = { class: "form-menu" };
const _hoisted_4 = { class: "float-end" };
const _hoisted_5 = { class: "form-contents" };
const _hoisted_6 = { class: "row" };
const _hoisted_7 = { class: "clearfix" };
const _hoisted_8 = { class: "col-xs-12 col-sm-12 col-md-4" };
const _hoisted_9 = { class: "input-group top_search" };
const _hoisted_10 = { class: "input-group-btn" };
const _hoisted_11 = { class: "col-xs-12 col-sm-12" };
const _hoisted_12 = { class: "card bg-white data-grid detached overflow-x-auto" };
const _hoisted_13 = { class: "table table-hover bottom0 pw100" };
const _hoisted_14 = { class: "invalid-feedback" };
const _hoisted_15 = { class: "text-end" };
const _hoisted_16 = { key: 0 };
const _hoisted_17 = { class: "data-grid-footer clearfix detached pw100" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_b_button = _resolveComponent("b-button");
    const _component_b_form_input = _resolveComponent("b-form-input");
    const _component_b_form_select = _resolveComponent("b-form-select");
    const _component_b_pagination = _resolveComponent("b-pagination");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _cache[4] || (_cache[4] = _createElementVNode("div", { class: "form-title" }, [
                _createElementVNode("h2", null, "\r\n\t\t\t\t\tGeographic Regions\r\n\t\t\t\t")
            ], -1 /* CACHED */)),
            _cache[5] || (_cache[5] = _createTextVNode()),
            _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_b_button, {
                        variant: "primary",
                        onClick: _ctx.add
                    }, {
                        default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                                _createElementVNode("span", { class: "fa fa-plus" }, null, -1 /* CACHED */),
                                _createElementVNode("span", { class: "hidden-xs" }, " Add Region", -1 /* CACHED */)
                            ]))]),
                        _: 1 /* STABLE */
                    }, 8 /* PROPS */, ["onClick"])
                ])
            ])
        ]),
        _cache[20] || (_cache[20] = _createTextVNode()),
        _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("div", _hoisted_9, [
                            _createVNode(_component_b_form_input, {
                                type: "text",
                                modelValue: _ctx.query.keywords,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.query.keywords) = $event)),
                                modelModifiers: { trim: true },
                                placeholder: "Search for...",
                                onKeyup: _withKeys(_ctx.search, ["enter"]),
                                required: ""
                            }, null, 8 /* PROPS */, ["modelValue", "onKeyup"]),
                            _cache[7] || (_cache[7] = _createTextVNode()),
                            _createElementVNode("span", _hoisted_10, [
                                _createElementVNode("button", {
                                    type: "button",
                                    class: "btn btn-default",
                                    onClick: _cache[1] || (_cache[1] =
                                        //@ts-ignore
                                        (...args) => (_ctx.search && _ctx.search(...args)))
                                }, [...(_cache[6] || (_cache[6] = [
                                        _createElementVNode("i", { class: "fa fa-search" }, null, -1 /* CACHED */)
                                    ]))])
                            ])
                        ])
                    ])
                ]),
                _cache[19] || (_cache[19] = _createTextVNode()),
                _withDirectives(_createElementVNode("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        _createElementVNode("table", _hoisted_13, [
                            _cache[15] || (_cache[15] = _createElementVNode("thead", null, [
                                _createElementVNode("tr", null, [
                                    _createElementVNode("th", { class: "min-width300 w300" }, "\r\n\t\t\t\t\t\t\t\t\t\tRegion\r\n\t\t\t\t\t\t\t\t\t"),
                                    _createTextVNode(),
                                    _createElementVNode("th", { class: "min-width200 w200" }, "\r\n\t\t\t\t\t\t\t\t\t\tCountry\r\n\t\t\t\t\t\t\t\t\t"),
                                    _createTextVNode(),
                                    _createElementVNode("th", { class: "w100" })
                                ])
                            ], -1 /* CACHED */)),
                            _cache[16] || (_cache[16] = _createTextVNode()),
                            _createElementVNode("tbody", null, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data.records, (item) => {
                                    return (_openBlock(), _createElementBlock("tr", null, [
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_b_form_input, {
                                                type: "text",
                                                modelValue: item.regionName,
                                                "onUpdate:modelValue": ($event) => ((item.regionName) = $event),
                                                modelModifiers: { trim: true },
                                                class: _normalizeClass({ 'is-invalid': !item.regionName }),
                                                maxlength: "50"
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "class"]),
                                            _cache[8] || (_cache[8] = _createTextVNode()),
                                            _withDirectives(_createElementVNode("div", _hoisted_14, "\r\n\t\t\t\t\t\t\t\t\t\t\tThe Region Name field is required.\r\n\t\t\t\t\t\t\t\t\t\t", 512 /* NEED_PATCH */), [
                                                [_vShow, !item.regionName]
                                            ])
                                        ]),
                                        _cache[12] || (_cache[12] = _createTextVNode()),
                                        _createElementVNode("td", null, [
                                            _createVNode(_component_b_form_select, {
                                                modelValue: item.countryId,
                                                "onUpdate:modelValue": ($event) => ((item.countryId) = $event),
                                                options: _ctx.countries
                                            }, null, 8 /* PROPS */, ["modelValue", "onUpdate:modelValue", "options"])
                                        ]),
                                        _cache[13] || (_cache[13] = _createTextVNode()),
                                        _createElementVNode("td", _hoisted_15, [
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: ($event) => (_ctx.save(item))
                                            }, {
                                                default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                                                        _createElementVNode("i", { class: "fa fa-save" }, null, -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"]),
                                            _cache[11] || (_cache[11] = _createTextVNode()),
                                            _createVNode(_component_b_button, {
                                                type: "button",
                                                variant: "primary",
                                                onClick: ($event) => (_ctx.purge(item))
                                            }, {
                                                default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                                                        _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */)
                                                    ]))]),
                                                _: 1 /* STABLE */
                                            }, 8 /* PROPS */, ["onClick"])
                                        ])
                                    ]));
                                }), 256 /* UNKEYED_FRAGMENT */))
                            ]),
                            _cache[17] || (_cache[17] = _createTextVNode()),
                            (_ctx.noData)
                                ? (_openBlock(), _createElementBlock("tfoot", _hoisted_16, [...(_cache[14] || (_cache[14] = [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("td", {
                                                class: "text-center",
                                                colspan: "3"
                                            }, [
                                                _createElementVNode("h5", null, "\r\n\t\t\t\t\t\t\t\t\t\t\tThere are no records matching your criteria.\r\n\t\t\t\t\t\t\t\t\t\t")
                                            ])
                                        ], -1 /* CACHED */)
                                    ]))]))
                                : _createCommentVNode("v-if", true)
                        ])
                    ]),
                    _cache[18] || (_cache[18] = _createTextVNode()),
                    _createElementVNode("div", _hoisted_17, [
                        _createVNode(_component_b_pagination, {
                            class: "float-end",
                            modelValue: _ctx.query.pageNo,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event) => ((_ctx.query.pageNo) = $event)),
                            "per-page": _ctx.query.pageSize,
                            "total-rows": _ctx.data.recordCount,
                            "hide-ellipsis": true,
                            disabled: _ctx.working
                        }, null, 8 /* PROPS */, ["modelValue", "per-page", "total-rows", "disabled"])
                    ])
                ], 512 /* NEED_PATCH */), [
                    [_vShow, _ctx.searchAttempted]
                ])
            ])
        ])
    ]));
}
